import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Cta from '../components/Cta';
import { useLanguage } from '../context/LanguageContext';

const NEWS = [
  { video: '/assets/video/news-cnbc-interview-2025.mp4', tag: { ar: 'مقابلة تلفزيونية', en: 'TV Interview' }, img: 'news-cnbc-interview-2025-poster.webp', date: { ar: '29 يوليو 2025 · CNBC عربية', en: '29 July 2025 · CNBC Arabia' }, title: { ar: 'مقابلة المهندس هيثم الهواري — رئيس لجنة الزراعة بغرفة الصناعات الغذائية — مع قناة CNBC عربية', en: 'Eng. Haitham Elhaware’s interview with CNBC Arabia on agriculture and the food industries' }, delay: '1' },
  { href: 'https://www.alborsaanews.com/2023/12/25/1749850', tag: { ar: 'استثمار', en: 'Investment' }, img: 'news-alborsaa-2023.webp', date: { ar: '25 ديسمبر 2023 · جريدة البورصة', en: '25 December 2023 · Al-Borsa' }, title: { ar: 'تحالف مصرى يستثمر مليار جنيه لاستصلاح 20 ألف فدان بـ«الوادى الجديد»', en: 'تحالف مصرى يستثمر مليار جنيه لاستصلاح 20 ألف فدان بـ«الوادى الجديد»' }, delay: '1' },
  { href: 'https://www.youm7.com/story/2024/11/28/6793103', tag: { ar: 'اقتصاد وبورصة', en: 'Economy & Stocks' }, img: 'img_1588eb43db1e.webp', date: { ar: '28 نوفمبر 2024 · اليوم السابع', en: '28 November 2024 · Youm7' }, title: { ar: 'استثمارات مصرية صينية في سوهاج في مجالات التصنيع الغذائي', en: 'استثمارات مصرية صينية في سوهاج في مجالات التصنيع الغذائي' }, delay: '1' },
  { href: 'https://regalalamal.com/329283/', tag: { ar: 'رجال الأعمال', en: 'Business' }, img: 'img_a1a905cef779.webp', date: { ar: '10 أكتوبر 2024 · رجال الأعمال', en: '10 October 2024 · Regal Al-Amal' }, title: { ar: 'هيثم الهواري: أشكر وزير المالية على إقرار التيسيرات ونطالب بخطوات جريئة لمساندة القطاع الخاص الصناعي والزراعي', en: 'هيثم الهواري: أشكر وزير المالية على إقرار التيسيرات ونطالب بخطوات جريئة لمساندة القطاع الخاص الصناعي والزراعي' }, delay: '2' },
  { href: 'https://www.albawabhnews.com/5112539', tag: { ar: 'اقتصاد عربي', en: 'Arab Economy' }, img: 'img_e84717d2b271.webp', date: { ar: '28 نوفمبر 2024 · البوابة نيوز', en: '28 November 2024 · Al-Bawaba News' }, title: { ar: 'استثمارات «مصرية صينية» في التصنيع الغذائي وتوريد معدات زراعة قصب السكر بسوهاج', en: 'استثمارات «مصرية صينية» في التصنيع الغذائي وتوريد معدات زراعة قصب السكر بسوهاج' }, delay: '3' },
  { href: 'https://www.albawabhnews.com/5092097', tag: { ar: 'اقتصاد عربي', en: 'Arab Economy' }, img: 'img_9160552566a0.webp', date: { ar: '28 نوفمبر 2024 · البوابة نيوز', en: '28 November 2024 · Al-Bawaba News' }, title: { ar: 'مشاركة مصر في قمة بريكس خطوة إستراتيجية نحو تعزيز النمو الاقتصادي', en: 'مشاركة مصر في قمة بريكس خطوة إستراتيجية نحو تعزيز النمو الاقتصادي' }, delay: '1' },
  { href: 'https://www.albawabhnews.com/5108699', tag: { ar: 'اقتصاد', en: 'Economy' }, img: 'img_27413a7ffaf7.webp', date: { ar: '28 نوفمبر 2024 · البوابة نيوز', en: '28 November 2024 · Al-Bawaba News' }, title: { ar: 'هيثم الهواري: معرض «EGY AGRI» يحقق التكامل بين الإنتاج الزراعي والصناعي', en: 'هيثم الهواري: معرض «EGY AGRI» يحقق التكامل بين الإنتاج الزراعي والصناعي' }, delay: '2' },
  { href: 'https://almalnews.com/', tag: { ar: 'اقتصاد', en: 'Economy' }, img: 'img_8467a6596708.webp', date: { ar: '1 أكتوبر 2024 · المال', en: '1 October 2024 · Al-Mal' }, title: { ar: '«المصرية اللبنانية» تطالب بإعادة النظر في الضريبة على توزيع الأرباح لبناء اقتصاد مستدام وقوي', en: '«المصرية اللبنانية» تطالب بإعادة النظر في الضريبة على توزيع الأرباح لبناء اقتصاد مستدام وقوي' }, delay: '3' },
];

const VIDEOS = [
  { yt: 'z3HxFKtyJis', title: { ar: 'الانتهاء من تجهيز عنابر تربية الدواجن بدولة السنغال', en: 'Completion of poultry-rearing halls in Senegal' }, img: 'img_35d02d4337ad.webp', date: { ar: '28 نوفمبر 2024', en: '28 November 2024' }, delay: '1' },
  { yt: 'SxGcrHCwJzA', title: { ar: 'تشغيل مزرعة الدواجن بدولة السنغال', en: 'Operating the poultry farm in Senegal' }, img: 'img_3715007972a7.webp', date: { ar: '28 نوفمبر 2024', en: '28 November 2024' }, delay: '2' },
  { yt: 'X2gtaRy7csU', title: { ar: 'مصنع أعلاف العصر .. إحدى شركات الهواري جروب', en: 'Al-Asr Feed Factory — one of Elhaware Group companies' }, img: 'img_4015ba60d8b4.webp', date: { ar: '28 نوفمبر 2024', en: '28 November 2024' }, delay: '3' },
  { yt: 'YfdezmWFHxw', title: { ar: 'هيثم الهواري يشارك في معرض الكتاب بـ«أصحاب الرؤوس البيضاء»', en: 'Haitham Elhaware at the Book Fair with "The White-Headed"' }, img: 'img_6742726f089b.webp', date: { ar: '4 فبراير 2024', en: '4 February 2024' }, delay: '1' },
  { yt: 'fAjS9835jlo', title: { ar: 'الهواري للنقل الثقيل والمواد السائلة', en: 'Elhaware for Heavy Transport & Liquid Materials' }, img: 'img_2dbd4bcdd7d1.webp', date: { ar: '28 نوفمبر 2024', en: '28 November 2024' }, delay: '2' },
  { yt: 'l89A0kKVIgE', title: { ar: 'الهواري للتنمية الزراعية', en: 'Elhaware for Agricultural Development' }, img: 'img_0245b96a0c13.webp', date: { ar: '28 نوفمبر 2024', en: '28 November 2024' }, delay: '3' },
];

const GALLERY = [
  { img: 'img_81ce1bd6d963.webp', cap: { ar: 'استثمارات مصرية صينية في سوهاج في مجالات التصنيع الغذائي', en: 'Egyptian-Chinese investments in food manufacturing in Sohag' }, short: { ar: 'استثمارات مصرية صينية — التصنيع الغذائي', en: 'Egyptian-Chinese investments — food manufacturing' }, delay: '1' },
  { img: 'img_1b62fb62ad8b.webp', cap: { ar: 'استثمارات مصرية صينية في سوهاج في مجالات التصنيع الغذائي', en: 'Egyptian-Chinese investments in food manufacturing in Sohag' }, short: { ar: 'استثمارات مصرية صينية — التصنيع الغذائي', en: 'Egyptian-Chinese investments — food manufacturing' }, delay: '2' },
  { img: 'img_f4357b32cdd4.webp', cap: { ar: 'استثمارات مصرية صينية في سوهاج في مجالات التصنيع الغذائي', en: 'Egyptian-Chinese investments in food manufacturing in Sohag' }, short: { ar: 'استثمارات مصرية صينية — التصنيع الغذائي', en: 'Egyptian-Chinese investments — food manufacturing' }, delay: '3' },
  { img: 'img_53763bfeb54d.webp', cap: { ar: 'استثمارات مصرية صينية في سوهاج في مجالات التصنيع الغذائي', en: 'Egyptian-Chinese investments in food manufacturing in Sohag' }, short: { ar: 'استثمارات مصرية صينية — التصنيع الغذائي', en: 'Egyptian-Chinese investments — food manufacturing' }, delay: '1' },
  { img: 'img_de265dd237b4.webp', cap: { ar: 'استثمارات مصرية صينية في سوهاج في مجالات التصنيع الغذائي', en: 'Egyptian-Chinese investments in food manufacturing in Sohag' }, short: { ar: 'استثمارات مصرية صينية — التصنيع الغذائي', en: 'Egyptian-Chinese investments — food manufacturing' }, delay: '2' },
  { img: 'img_72630964f8fd.webp', cap: { ar: 'معرض «EGY AGRI» الوادي الجديد الزراعي', en: '"EGY AGRI" Exhibition — New Valley Agriculture' }, short: { ar: 'معرض «EGY AGRI» الوادي الجديد الزراعي', en: '"EGY AGRI" Exhibition — New Valley Agriculture' }, delay: '3' },

  { img: 'ceo-vineyard.webp', cap: { ar: 'متابعةٌ ميدانية لمزارع العنب', en: 'A field visit to the grape farms' }, short: { ar: 'متابعةٌ ميدانية لمزارع العنب', en: 'Grape-farm field visit' }, delay: '1' },
  { img: 'ceo-speech.webp', cap: { ar: 'كلمةٌ في احتفالية شباب سوهاج', en: 'A speech at the Sohag Youth celebration' }, short: { ar: 'كلمةٌ في احتفالية شباب سوهاج', en: 'Sohag Youth celebration speech' }, delay: '2' },
  { img: 'ceo-event.webp', cap: { ar: 'حضورٌ في الفعاليات الرسمية والمجتمعية', en: 'Attending official and community events' }, short: { ar: 'حضورٌ في الفعاليات الرسمية والمجتمعية', en: 'Official & community events' }, delay: '3' },
  { img: 'ceo-honor.webp', cap: { ar: 'تكريمٌ وشراكات مع القيادات', en: 'Honors and partnerships with leaders' }, short: { ar: 'تكريمٌ وشراكات مع القيادات', en: 'Honors & partnerships' }, delay: '1' },
  { img: 'ceo-factory.webp', cap: { ar: 'زيارةٌ لمنشآت التصنيع', en: 'A visit to the manufacturing facilities' }, short: { ar: 'زيارةٌ لمنشآت التصنيع', en: 'Manufacturing facilities visit' }, delay: '2' },
  { img: 'ceo-plant.webp', cap: { ar: 'جولةٌ في المصانع والمنشآت الصناعية', en: 'A tour of the factories and industrial facilities' }, short: { ar: 'جولةٌ في المصانع والمنشآت الصناعية', en: 'Factories & industrial tour' }, delay: '3' },
  { img: 'ceo-masr.webp', cap: { ar: 'جولةٌ في جهاز مستقبل مصر', en: 'A tour of the Egypt Future Device' }, short: { ar: 'جولةٌ في جهاز مستقبل مصر', en: 'A tour of the Egypt Future Device' }, delay: '3' },
  { img: 'family.webp', cap: { ar: 'جولةٌ حية من ارضينا وسط اهلينا', en: 'A live tour from our land among our people.' }, short: { ar: 'جولةٌ حية من ارضينا وسط اهلينا', en: 'A live tour from our land among our people.' }, delay: '3' },
  { img: 'family2.webp', cap: { ar: 'جولةٌ حية من ارضينا وسط اهلينا', en: 'A live tour from our land among our people.' }, short: { ar: 'جولةٌ حية من ارضينا وسط اهلينا', en: 'A live tour from our land among our people.' }, delay: '3' },
  { img: 'family3.webp', cap: { ar: 'جولةٌ حية من ارضينا وسط اهلينا', en: 'A live tour from our land among our people.' }, short: { ar: 'جولةٌ حية من ارضينا وسط اهلينا', en: 'A live tour from our land among our people.' }, delay: '3' },
];

const TABS = [
  { key: 'news', label: { ar: 'الأخبار والمقالات', en: 'News & Articles' } },
  { key: 'videos', label: { ar: 'الفيديوهات', en: 'Videos' } },
  { key: 'gallery', label: { ar: 'ألبوم الصور', en: 'Photo Album' } },
];

const TAB_COUNTS = { news: NEWS.length, videos: VIDEOS.length, gallery: GALLERY.length };

export default function MediaCenterPage() {
  const { isEN, t } = useLanguage();
  const [activeTab, setActiveTab] = useState('news');
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    document.title = isEN ? 'Media Center — Elhaware Group' : 'المركز الإعلامي — مجموعة الهواري';
  }, [isEN]);

  useEffect(() => {
    const panel = document.querySelector(`.mc-panel[data-panel="${activeTab}"]`);
    if (!panel) return;
    panel.querySelectorAll('[data-reveal]').forEach((el, i) => {
      setTimeout(() => el.classList.add('in'), 40 * i);
    });
  }, [activeTab]);

  useEffect(() => {
    if (!lightbox) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setLightbox(null); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [lightbox]);

  const selectTab = (name) => {
    setActiveTab(name);
    const tabsEl = document.querySelector('.mc-tabs');
    if (tabsEl) window.scrollTo({ top: tabsEl.offsetTop - 70, behavior: 'smooth' });
  };

  return (
    <>
      <section className="page-hero">
        <div className="page-hero__bg">
          <div className="ph shot" data-parallax="0.08" role="img" aria-label={isEN ? 'Group events and exhibitions' : 'فعاليات ومعارض المجموعة'} style={{ backgroundImage: "url('/assets/img/ceo-speech.webp')" }}></div>
        </div>
        <div className="page-hero__glow"></div>
        <div className="wrap">
          <nav className="breadcrumb" data-reveal="fade"><Link to="/">{isEN ? 'Home' : 'الرئيسية'}</Link><span>/</span><span style={{ color: 'rgba(255,255,255,.85)' }}>{isEN ? 'Media Center' : 'المركز الإعلامي'}</span></nav>
          <span className="eyebrow" data-reveal>{isEN ? 'Media Center' : 'المركز الإعلامي'}</span>
          <h1 data-reveal data-delay="1">{isEN ? <>Our news &amp; <b>top articles</b><br />photos and videos</> : <>أخبارنا و<b>أهم المقالات</b><br />والصور والفيديوهات</>}</h1>
          <p className="page-hero__lead" data-reveal data-delay="2">{isEN ? 'The Media Center showcases photos, videos, participations and events across all the business fields in which Elhaware Group operates, inside and outside Egypt.' : 'يعرض المركز الإعلامي الصور والفيديوهات والمشاركات والفاعليات الخاصة في كل مجالات الأعمال التي تشارك فيها مجموعة الهواري داخل مصر وخارجها.'}</p>
        </div>
      </section>

      <div className="mc-tabs">
        <div className="wrap mc-tabs__inner">
          {TABS.map((tab) => (
            <button className={'mc-tab' + (activeTab === tab.key ? ' is-active' : '')} type="button" onClick={() => selectTab(tab.key)} key={tab.key}>
              {t(tab.label)} <span className="mc-tab__count">{String(TAB_COUNTS[tab.key]).padStart(2, '0')}</span>
            </button>
          ))}
        </div>
      </div>

      <section className={'mc-panel' + (activeTab === 'news' ? ' is-active' : '')} data-panel="news">
        <div className="section">
          <div className="wrap">
            <div className="shead" data-reveal>
              <span className="eyebrow">{isEN ? 'Press & Insights' : 'صحافة ورؤى'}</span>
              <h2>{isEN ? <>What the press said about <b>the Group and its Chairman</b></> : <>أهم ما ذكرته الصحافة عن <b>المجموعة ورئيس مجلس إدارتها</b></>}</h2>
            </div>
            <div className="news-grid">
              {NEWS.map((n) => {
                const body = (
                  <>
                    <div className="news-card__media">
                      <span className="news-card__tag">{t(n.tag)}</span>
                      <img className="news-card__img" loading="lazy" src={`/assets/img/${n.img}`} alt="" />
                      {n.video && <span className="video-card__play"><span className="video-card__tri"></span></span>}
                    </div>
                    <div className="news-card__body">
                      <span className="news-card__date">{t(n.date)}</span>
                      <h3 className="news-card__title">{t(n.title)}</h3>
                      <span className="news-card__more">{n.video ? (isEN ? 'Watch video' : 'شاهد الفيديو') : (isEN ? 'Read article' : 'اقرأ الخبر')} <span className="arr">←</span></span>
                    </div>
                  </>
                );
                return n.video ? (
                  <button type="button" className="news-card" data-reveal data-delay={n.delay} key={n.video} onClick={() => setLightbox({ type: 'video', src: n.video, local: true, caption: t(n.title) })}>
                    {body}
                  </button>
                ) : (
                  <a className="news-card" href={n.href} target="_blank" rel="noopener noreferrer" data-reveal data-delay={n.delay} key={n.href}>
                    {body}
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className={'mc-panel' + (activeTab === 'videos' ? ' is-active' : '')} data-panel="videos">
        <div className="section mc-videos">
          <div className="wrap">
            <div className="shead" data-reveal>
              <span className="eyebrow">{isEN ? 'Video Library' : 'مكتبة الفيديو'}</span>
              <h2 style={{ color: '#fff' }}>{isEN ? <>A visual record of the Group&apos;s activities across <b style={{ color: 'var(--champagne)' }}>factories, farms and transport fleet</b></> : <>توثيقٌ مرئيٌّ لأنشطة المجموعة من <b style={{ color: 'var(--champagne)' }}>مصانع ومزارع وأسطول نقل</b></>}</h2>
            </div>
            <div className="video-grid">
              {VIDEOS.map((v) => (
                <button
                  className="video-card"
                  type="button"
                  data-reveal
                  data-delay={v.delay}
                  key={v.yt}
                  onClick={() => setLightbox({ type: 'video', src: `https://www.youtube.com/embed/${v.yt}?autoplay=1&rel=0&modestbranding=1`, caption: t(v.title) })}
                >
                  <div className="video-card__media"><img className="video-card__img" loading="lazy" src={`/assets/img/${v.img}`} alt="" /><span className="video-card__play"><span className="video-card__tri"></span></span></div>
                  <h3 className="video-card__title">{t(v.title)}</h3>
                  <p className="video-card__date">{t(v.date)}</p>
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className={'mc-panel' + (activeTab === 'gallery' ? ' is-active' : '')} data-panel="gallery">
        <div className="section">
          <div className="wrap">
            <div className="shead" data-reveal>
              <span className="eyebrow">{isEN ? 'Photo Album' : 'ألبوم الصور'}</span>
              <h2>{isEN ? <>Shots that document <b>the Group&apos;s events and participations</b></> : <>لقطاتٌ توثّق <b>فعاليات المجموعة ومشاركاتها</b></>}</h2>
            </div>
            <div className="gallery-grid">
              {GALLERY.map((g) => (
                <button
                  className="gallery-item"
                  type="button"
                  data-reveal
                  data-delay={g.delay}
                  key={g.img}
                  onClick={() => setLightbox({ type: 'image', src: `/assets/img/${g.img}`, caption: t(g.cap) })}
                >
                  <img className="gallery-item__img" loading="lazy" src={`/assets/img/${g.img}`} alt="" /><span className="gallery-item__cap">{t(g.short)}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Cta />

      <div
        className={'mc-lightbox' + (lightbox ? ' is-open' : '')}
        aria-hidden={lightbox ? 'false' : 'true'}
        onClick={(e) => { if (e.target === e.currentTarget) setLightbox(null); }}
      >
        <button className="mc-lightbox__close" aria-label={isEN ? 'Close' : 'إغلاق'} onClick={() => setLightbox(null)}>✕</button>
        <div className="mc-lightbox__frame">
          <div className="mc-lightbox__stage">
            {lightbox && lightbox.type === 'video' && (
              <div className="mc-lightbox__video">
                {lightbox.local ? (
                  <video src={lightbox.src} controls autoPlay playsInline></video>
                ) : (
                  <iframe src={lightbox.src} title={isEN ? 'Video' : 'فيديو'} allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen></iframe>
                )}
              </div>
            )}
            {lightbox && lightbox.type === 'image' && (
              <img className="mc-lightbox__img" src={lightbox.src} alt="" />
            )}
          </div>
          <p className="mc-lightbox__cap">{lightbox ? lightbox.caption : ''}</p>
        </div>
      </div>
    </>
  );
}
